import { WHITE_LABEL_CONFIG } from './white_label';

export const privacyNoticeHTML = `
<div>
    <strong>${WHITE_LABEL_CONFIG.BRAND_NAME} customer privacy notice</strong>
    <p>This privacy notice tells you what to expect us to do with your personal information.</p>

    <ul>
        <li>Contact details</li>
        <li>What information we collect, use, and why</li>
        <li>Lawful bases and data protection rights</li>
        <li>Where we get personal information from</li>
        <li>How long we keep information</li>
        <li>Who we share information with</li>
        <li>Sharing information outside the UK</li>
        <li>How to complain</li>
    </ul>

    <strong>Contact details</strong>
    <p>Email: ${WHITE_LABEL_CONFIG.SUPPORT_EMAIL}</p>

    <p><strong>What information we collect, use, and why</strong></p>
    <p>We collect or use the following information for student education and welfare:</p>
    <ul>
        <li>Names and contact details for students/children</li>
        <li>Names and contact details for parents, guardians, carers</li>
        <li>Gender</li>
        <li>Pronoun preferences</li>
        <li>Date of birth</li>
        <li>Payment details and financial information including transactions</li>
        <li>Attendance and reason for absence data</li>
        <li>Account access information</li>
        <li>Exam results and qualifications</li>
        <li>Progress reports</li>
        <li>Information relating to compliments and complaints</li>
    </ul>

    <p>We also collect or use the following special category information for student education and welfare. This information is subject to additional protection due to its sensitive nature:</p>
    <ul>
        <li>Racial or ethnic origin</li>
        <li>Religious or philosophical beliefs</li>
    </ul>

    <p>We collect or use the following personal information for dealing with queries, complaints or claims:</p>
    <ul>
        <li>Names and contact details</li>
        <li>Addresses</li>
        <li>Payment details</li>
        <li>Account login or user information</li>
        <li>Purchase or service history</li>
        <li>Correspondence</li>
        <li>Attendance and reason for absence data</li>
    </ul>

    <p>We collect or use the following information for information updates or marketing purposes:</p>
    <ul>
        <li>Names and contact details</li>
        <li>Addresses</li>
        <li>Marketing preferences</li>
        <li>Website and app user journey information</li>
        <li>IP addresses</li>
        <li>Records of consent, where appropriate</li>
        <li>Alumni records</li>
        <li>Heatmap data</li>
    </ul>

    <p>We also collect or use the following special category information for information updates or marketing purposes. This information is subject to additional protection due to its sensitive nature:</p>
    <ul>
        <li>Racial or ethnic origin</li>
    </ul>

    <p>We collect or use the following information to comply with legal requirements:</p>
    <ul>
        <li>Any other personal information required to comply with legal obligations</li>
    </ul>

    <strong>Lawful bases and data protection rights</strong>
    <p>Under UK data protection law, we must have a "lawful basis" for collecting and using your personal information. There is a list of possible lawful bases in the UK GDPR. You can find out more about lawful bases on the ICO's website.</p>
    <p>Which lawful basis we rely on may affect your data protection rights which are set out in brief below. You can find out more about your data protection rights and the exemptions which may apply on the ICO's website:</p>

    <ul>
        <li><strong>Your right of access</strong> - You have the right to ask us for copies of your personal information. You can request other information such as details about where we get personal information from and who we share personal information with. There are some exemptions which means you may not receive all the information you ask for.</li>
        <li><strong>Your right to rectification</strong> - You have the right to ask us to correct or delete personal information you think is inaccurate or incomplete.</li>
        <li><strong>Your right to erasure</strong> - You have the right to ask us to delete your personal information.</li>
        <li><strong>Your right to restriction of processing</strong> - You have the right to ask us to limit how we can use your personal information.</li>
        <li><strong>Your right to object to processing</strong> - You have the right to object to the processing of your personal data.</li>
        <li><strong>Your right to data portability</strong> - You have the right to ask that we transfer the personal information you gave us to another organisation, or to you.</li>
        <li><strong>Your right to withdraw consent</strong> – When we use consent as our lawful basis you have the right to withdraw your consent at any time.</li>
    </ul>

    <p>If you make a request, we must respond to you without undue delay and in any event within one month. To make a data protection rights request, please contact us using the contact details at the top of this privacy notice.</p>

    <strong>Our lawful bases for the collection and use of your data</strong>
    
    <p><strong>Our lawful bases for collecting or using personal information for student education and welfare are:</strong></p>
    <ul>
        <li>Consent - we have permission from you after we gave you all the relevant information. All of your data protection rights may apply, except the right to object. To be clear, you do have the right to withdraw your consent at any time.</li>
        <li>Contract - we have to collect or use the information so we can enter into or carry out a contract with you. All of your data protection rights may apply except the right to object.</li>
        <li>Legitimate interests – we're collecting or using your information because it benefits you, our organisation or someone else, without causing an undue risk of harm to anyone. All of your data protection rights may apply, except the right to portability. Our legitimate interests are: To offer better or more appropriate educational services.</li>
    </ul>

    <p><strong>Our lawful bases for collecting or using personal information for dealing with queries, complaints or claims are:</strong></p>
    <ul>
        <li>Consent - we have permission from you after we gave you all the relevant information. All of your data protection rights may apply, except the right to object. To be clear, you do have the right to withdraw your consent at any time.</li>
        <li>Contract - we have to collect or use the information so we can enter into or carry out a contract with you. All of your data protection rights may apply except the right to object.</li>
        <li>Legitimate interests – we're collecting or using your information because it benefits you, our organisation or someone else, without causing an undue risk of harm to anyone. All of your data protection rights may apply, except the right to portability. Our legitimate interests are: To identify the user or in regards to any of the services we provide.</li>
    </ul>

    <p><strong>Our lawful bases for collecting or using personal information for information updates or marketing purposes are:</strong></p>
    <ul>
        <li>Consent - we have permission from you after we gave you all the relevant information. All of your data protection rights may apply, except the right to object. To be clear, you do have the right to withdraw your consent at any time.</li>
        <li>Contract - we have to collect or use the information so we can enter into or carry out a contract with you. All of your data protection rights may apply except the right to object.</li>
        <li>Legal obligation - we have to collect or use your information so we can comply with the law. All of your data protection rights may apply, except the right to erasure, the right to object and the right to data portability.</li>
        <li>Legitimate interests – we're collecting or using your information because it benefits you, our organisation or someone else, without causing an undue risk of harm to anyone. All of your data protection rights may apply, except the right to portability. Our legitimate interests are: To offer better or more appropriate educational services.</li>
    </ul>

    <p><strong>Our lawful bases for collecting or using personal information to comply with legal requirements are:</strong></p>
    <ul>
        <li>Consent - we have permission from you after we gave you all the relevant information. All of your data protection rights may apply, except the right to object. To be clear, you do have the right to withdraw your consent at any time.</li>
        <li>Contract - we have to collect or use the information so we can enter into or carry out a contract with you. All of your data protection rights may apply except the right to object.</li>
        <li>Legal obligation - we have to collect or use your information so we can comply with the law. All of your data protection rights may apply, except the right to erasure, the right to object and the right to data portability.</li>
        <li>Legitimate interests – we're collecting or using your information because it benefits you, our organisation or someone else, without causing an undue risk of harm to anyone. All of your data protection rights may apply, except the right to portability. Our legitimate interests are: To provide law with any information required by law.</li>
    </ul>

    <strong>Where we get personal information from</strong>
    <ul>
        <li>Directly from you</li>
        <li>Parents or carers</li>
    </ul>

    <strong>How long we keep information</strong>
    <p>We apply different retention periods depending on the type of information and our ongoing relationship with you:</p>
    <ul>
        <li><strong>Active Subscriptions and Ongoing Services:</strong> For users using our diagnostic services over multiple years, we retain student academic records (names and test scores) for the entire duration of the active relationship. This is necessary to provide year-on-year progress tracking and comparative analysis.</li>
        <li><strong>Post-Service Retention:</strong> Once you cease using our services or your subscription ends, we will retain student academic data for a further 24 months. This "grace period" allows you to return to the service and access historical data for school transition purposes. After this time, the data is permanently deleted or anonymised.</li>
        <li><strong>Financial and Transactional Records:</strong> Records of payments, invoices, and subscriptions are retained for 6 years following the end of the financial year in which the transaction occurred. This is a mandatory requirement and overrides any individual request for data erasure.</li>
        <li><strong>Marketing and Analytics Data:</strong> Information collected via tracking pixels (Google, Meta, Microsoft) is retained for a maximum of 26 months from the date of your last visit, or until you withdraw your consent via our cookie settings.</li>
        <li><strong>Customer Support Enquiries:</strong> We retain general correspondence for 2 years to ensure we can resolve any follow-up issues or complaints effectively.</li>
    </ul>

    <strong>Who we share information with</strong>
    <p><strong>Data processors</strong></p>
    <p>Stripe Payments UK Ltd. UK / USA (Stripe is a global entity). This data processor does the following activities for us: Process secure credit/debit card transactions, and manage payment subscriptions.</p>
    <p>Vercel Inc. USA (or "Global"). This data processor does the following activities for us: Host web application and provide the infrastructure for marketing websites and service websites.</p>
    <p>DigitalOcean. USA (or "Global"). This data processor does the following activities for us: Host web application and provide the infrastructure for marketing websites and service websites.</p>
    <p>Microsoft. USA (or "Global"). This data processor does the following activities for us: Provide marketing services and analytics.</p>
    <p>Google. USA (or "Global"). This data processor does the following activities for us: Provide marketing services and analytics.</p>
    <p>Meta. USA (or "Global"). This data processor does the following activities for us: Provide marketing services and analytics.</p>
    <p>IONOS. German (European). This data processor does the following activities for us: Provides email storage and services.</p>

    <p><strong>Others we share personal information with</strong></p>
    <ul>
        <li>Parents and carers</li>
    </ul>

    <strong>Sharing information outside the UK</strong>
    <p>Where necessary, we will transfer personal information outside of the UK. When doing so, we comply with the UK GDPR, making sure appropriate safeguards are in place.</p>
    
    <p>Organisation name: Google<br>
    Category of recipient: Marketing<br>
    Country the personal information is sent to: USA<br>
    How the transfer complies with UK data protection law: The country or sector has a UK data bridge (also known as Adequacy Regulations)</p>

    <p>Organisation name: Microsoft<br>
    Category of recipient: Marketing<br>
    Country the personal information is sent to: USA<br>
    How the transfer complies with UK data protection law: The country or sector has a UK data bridge (also known as Adequacy Regulations)</p>

    <p>Organisation name: DigitalOcean<br>
    Category of recipient: Digital storage provider<br>
    Country the personal information is sent to: USA<br>
    How the transfer complies with UK data protection law: The country or sector has a UK data bridge (also known as Adequacy Regulations)</p>

    <p>Organisation name: Microsoft<br>
    Category of recipient: Marketing & Analytics<br>
    Country the personal information is sent to: USA<br>
    How the transfer complies with UK data protection law: The country or sector has a UK data bridge (also known as Adequacy Regulations)</p>

    <p>Organisation name: Meta<br>
    Category of recipient: Marketing & Analytics<br>
    Country the personal information is sent to: USA<br>
    How the transfer complies with UK data protection law: The country or sector has a UK data bridge (also known as Adequacy Regulations)</p>

    <p>Organisation name: Stripe<br>
    Category of recipient: Payment processor<br>
    Country the personal information is sent to: USA<br>
    How the transfer complies with UK data protection law: The country or sector has a UK data bridge (also known as Adequacy Regulations)</p>

    <p>Organisation name: Vercel<br>
    Category of recipient: Digital storage provider<br>
    Country the personal information is sent to: USA<br>
    How the transfer complies with UK data protection law: The country or sector has a UK data bridge (also known as Adequacy Regulations)</p>

    <p>Organisation name: IONOS<br>
    Category of recipient: Email provider<br>
    Country the personal information is sent to: Germany<br>
    How the transfer complies with UK data protection law: The country or sector has a UK data bridge (also known as Adequacy Regulations)</p>

    <strong>How to complain</strong>
    <p>If you have any concerns about our use of your personal data, you can make a complaint to us using the contact details at the top of this privacy notice.</p>
    <p>If you remain unhappy with how we've used your data after raising a complaint with us, you can also complain to the ICO.</p>
    <p>The ICO's address:<br>
    Information Commissioner's Office<br>
    Wycliffe House<br>
    Water Lane<br>
    Wilmslow<br>
    Cheshire<br>
    SK9 5AF</p>
    <p>Helpline number: 0303 123 1113<br>
    Website: https://www.ico.org.uk/make-a-complaint</p>
</div>
 `;
